import { fetchConfig } from '@theme/utilities';
import { CartUpdateEvent } from '@theme/events';

async function postJson(url, body) {
  const response = await fetch(url, fetchConfig('json', { body: JSON.stringify(body) }));
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
}

async function addVariant(variantId) {
  const formData = new FormData();
  formData.append('id', String(variantId));
  formData.append('quantity', '1');

  const fetchCfg = fetchConfig('javascript', { body: formData });
  const response = await fetch(Theme.routes.cart_add_url, {
    ...fetchCfg,
    headers: {
      ...fetchCfg.headers,
      Accept: 'application/json',
    },
  });

  const responseText = await response.text();
  const responseData = responseText ? JSON.parse(responseText) : {};

  if (!response.ok || responseData.status) {
    throw new Error(responseData.description || responseData.message || `Request failed: ${response.status}`);
  }
}

function getSectionIds() {
  const sectionIds = new Set();

  document.querySelectorAll('cart-items-component').forEach((component) => {
    if (component instanceof HTMLElement && component.dataset.sectionId) {
      sectionIds.add(component.dataset.sectionId);
    }
  });

  return Array.from(sectionIds);
}

async function refreshCartUI() {
  const sectionIds = getSectionIds();
  if (!sectionIds.length) return;

  const [sectionsResponse, cartResponse] = await Promise.all([
    fetch(`${window.location.pathname}?sections=${encodeURIComponent(sectionIds.join(','))}`),
    fetch(Theme.routes.cart_url + '.js'),
  ]);

  if (!sectionsResponse.ok || !cartResponse.ok) {
    throw new Error('Failed to refresh cart UI');
  }

  const sections = await sectionsResponse.json();
  const cart = await cartResponse.json();

  document.dispatchEvent(
    new CartUpdateEvent({}, 'cart-upsell-lite', {
      source: 'cart-upsell-lite',
      itemCount: cart.item_count,
      sections,
    })
  );
}

document.addEventListener('click', async (event) => {
  const addButton = event.target.closest('[data-cart-upsell-add]');
  const removeButton = event.target.closest('[data-cart-upsell-remove]');

  if (!addButton && !removeButton) return;

  const button = addButton || removeButton;
  if (!(button instanceof HTMLButtonElement)) return;

  button.disabled = true;

  try {
    if (addButton) {
      const variantId = addButton.getAttribute('data-variant-id');
      if (!variantId) throw new Error('Missing upsell variant id');

      await addVariant(variantId);
    }

    if (removeButton) {
      const lineKey = removeButton.getAttribute('data-line-key');
      if (!lineKey) throw new Error('Missing upsell line key');

      await postJson(Theme.routes.cart_change_url, {
        id: lineKey,
        quantity: 0,
      });
    }

    await refreshCartUI();
  } catch (error) {
    console.error('Upsell update failed', error);
    window.location.reload();
  }
});
